'use strict';

import utils from './utils';
const expirationDateErrorMessageSpacingFixToggle = document.documentElement.dataset.expirationDateErrorMessageSpacingFix;

function showAndHideTooltip(inputGroup) {
    for (let date of inputGroup) {
        let inputs = date.querySelectorAll('.input-date-field'),
            dateString = '';

        for (let input of inputs) {
            input.addEventListener('focus', function(){
                const field = input.closest('.field'),
                      dateGroup = input.closest('.input-composite'),
                      tooltip = field.querySelector('.tooltip');

                if (tooltip && dateGroup.classList.contains('error')) {
                    if (!tooltip.classList.contains('tooltip-display')) {
                        tooltip.classList.add('tooltip-display');
                    }
                }
            })

            input.addEventListener('blur', function(){
                const field = input.closest('.field'),
                      tooltip = field.querySelector('.tooltip');

                if (tooltip && tooltip.classList.contains('tooltip-display')) {
                    tooltip.classList.remove('tooltip-display');
                }
            })

            input.addEventListener('change', function(){
                let hasValue = true;

                const dateGroup = input.closest('.input-composite'),
                      field = input.closest('.field'),
                      inputs = dateGroup.querySelectorAll('.input-date-field');

                for (let i of inputs) {
                    if (!i.classList.contains('has-value')) {
                        hasValue = false;
                    }
                }

                if (hasValue && dateGroup.classList.contains('error')) {
                    dateGroup.classList.remove('error');
                    utils.removeErrorText(input);
                }
            })
        }
    }
}

// We use true for useCapture, because invalid does not bubble.
document.addEventListener('invalid', event =>  {
    event.preventDefault();
}, true);

document.addEventListener('submit', event => {
    const form = event.target,
          button = form.querySelector('button[data-clicked="true"],input[type=submit][data-clicked="true"]'),
          noValidate = (button && button.formNoValidate) || form.noValidate,
          inputGroup = expirationDateErrorMessageSpacingFixToggle
              ? document.querySelectorAll('.input-date-expiry')
              : document.querySelectorAll('input-date-expiry');
    for (const b of document.querySelectorAll(`button[type="submit"],
                                               button:not([type]),
                                               input[type=submit]`)) {
        delete b.dataset.clicked;
    }

    // Support Safari, iOS Safari, and the Android browser - each of which do
    // not prevent form submissions by default.

    !noValidate && !(!inputGroup.length ||(inputGroup.length && (expirationDateErrorMessageSpacingFixToggle ? utils : validationUtils).validateDate(inputGroup))) && !form.checkValidity() && event.preventDefault();
});

// We use true for useCapture, because blur does not bubble.
document.addEventListener('blur', event => {
    let target = event.target;
    if (['INPUT', 'TEXTAREA', 'SELECT'].indexOf(target.nodeName) >= 0
        && target.validity.valid
        && target.classList.contains('error')) {
        utils.removeErrorText(target);
    }

    if (target.classList && target.classList.contains('select2-selection')) {
        target = target.closest('.field').querySelector('select');

        if (target.validity.valid && target.classList.contains('error')) {
            utils.removeErrorText(target);
        }
    }

}, true);

document.addEventListener('click', event => {
    let target = event.target;
    if (target.nodeName === 'INPUT' && target.type === 'checkbox'
        && target.validity.valid
        && target.classList.contains('error')) {
        utils.removeErrorText(target);
    }
});

// CYT-22645: clear the Time Window error once a value is selected
// Toggle removal: drop only the if-check, keep the listener.
if (document.documentElement.dataset.airTimeWindowValidationFix) {
    document.addEventListener('change', event => {
        const target = event.target;
        if (target.nodeName === 'SELECT'
            && target.closest('.time-window-container')
            && target.validity.valid
            && target.classList.contains('error')) {
            utils.removeErrorText(target);
        }
    });
}

function init()
{
    const inputGroup = document.querySelectorAll('.input-date-expiry');
    showAndHideTooltip(inputGroup);

    for (const button of document.querySelectorAll(`button[type="submit"],
                                                    button:not([type]),
                                                    input[type=submit]`)) {
        button.addEventListener('click', e => {
            const button = e.target.closest(`button[type="submit"],
                                             button:not([type]),
                                             input[type=submit]`);

            const form = button.form;

            button.dataset.clicked = true;

            if (button.formNoValidate) {
                return;
            }

            utils.validateForm(form);
        });
    }
}

window.addEventListener('DOMContentLoaded', init);